import React from 'react'
import { Attributes } from '@leverege/ui-attributes'
import { DateTimeRangePicker } from '@leverege/ui-elements'
import GanttTableSplitView from './GanttTableSplitView'
import { getItems } from '../../../util'
import useOccupancyGraphData from './occupancyGraph/useOccupancyGraphData'

export default function GanttChart( props ) {
  
  // context/clientProps/settings is where i get the event query settings

  const { result, data, selected, parentItem, queryType = 'events', onTableResize, onClickLabel } = props
  
  const range = props?.context?.clientProps?.settings?.options?.range
  const timeRange = DateTimeRangePicker.getRange( range )
  const { start, end } = timeRange
  
  const { data : occupancyEvents } = useOccupancyGraphData( { ...props, timeRange } )
  const newMinTimeMS = start.getTime(), newMaxTimeMS = end.getTime()

  const filteredEvents = result.items?.filter( ( event ) => {
    const isCycleTrackingTypeEvent = event?.type === 'cycleTracking' 
    return isCycleTrackingTypeEvent
  } ).sort( ( a, b ) => {
    const aTimeMS = new Date( a.data.time ).getTime()
    const bTimeMS = new Date( b.data.time ).getTime()
    return aTimeMS - bTimeMS 
  } )
  
  const lines = data.items
  const moldHalves = lines.flatMap( ( line ) => {
    const { lwMold, uwMold } = line.data.data
    const ret = []
    if ( uwMold ) {
      uwMold.parentName = line.data.name
      ret.push( uwMold )
    } 
    if ( lwMold ) {
      lwMold.parentName = line.data.name
      ret.push( lwMold )
    }
    return ret
  } )
  const items = getItems( filteredEvents || [], moldHalves, occupancyEvents, {
    timezone : parentItem?.data?.metadata?.configuration?.operatingHours?.default?.timezone || 'America/Phoenix',
    queryType,
    timeRange : { rangeStartMS : newMinTimeMS, rangeEndMS : newMaxTimeMS, rangeString : timeRange }
  } )

  const { bins } = items

  const operatingHours = parentItem.data?.metadata?.configuration?.operatingHours?.default

  // if ( timeRange ) return <LoadingView title="No Data" />

  const keys = [ ...bins.entries() ]
    .sort( ( [ , dataA ], [ , dataB ] ) => {
      const nameA = Attributes.get( 'name', dataA.obj )
      const nameB = Attributes.get( 'name', dataB.obj )

      return nameA < nameB ? -1 : 1
    } )
    .map( item => item[0] )

  const moldHalfIndices = {}
  const hdrData = keys.map( ( k, index ) => {
    const item = bins.get( k )
    if ( !item.moldHalfObj ) {
      return {
        obj : item.obj
      }
    }
    if ( !moldHalfIndices[item.moldHalfObj?.id] ) {
      moldHalfIndices[item.moldHalfObj.id] = index + 1
    }
    return {
      obj : item.obj,
      workCellObj : item.moldHalfObj,
      workCellNum : moldHalfIndices[item.moldHalfObj.id]
    }
  } )
    .filter( i => i != null )
  const rows = keys.map( ( k ) => { return bins.get( k ).events } ).filter( i => i != null )
  return (
    <GanttTableSplitView 
      minTime={newMinTimeMS}
      maxTime={newMaxTimeMS}
      onTableResize={onTableResize}
      workCellIndices={moldHalfIndices}
      operatingHours={operatingHours}
      operatingHoursMargin={parentItem.data?.metadata?.configuration?.operating_hours_margin || 1800}
      headerData={hdrData}
      rows={rows}
      selected={selected}
      onClickLabel={onClickLabel}/>
  )

}
